export default {
    verb: 'doingCreate',
    namespace: 'security',
    relation: 'profile',
    type: 'confirm',
    prerequisites: [],
    description: 'Reset a user password',
    //this is the actual logic:
    logic: confirm
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function confirm() {
    throw new Error('Non-Auth0 code was not deleted correctly');
}
